module.exports = __webpack_public_path__ + "img/pxbm.fc8d080a.png";